import { c as _c } from "react/compiler-runtime";
import { useErrorContext } from "@context-providers/error-boundary/error-handling-context";
import { mapProjectsByArchivingStateSelector, mapProjectsFetchingStatusSelector } from "@store/projects-map/projects-map-selectors";
import { fetchMapProjects } from "@store/projects-map/projects-map-thunks";
import { useAppDispatch, useAppSelector } from "@store/store-helper";
import { useEffect, useMemo } from "react";
/**
 * Returns all the projects of the archiving state from the projects stream, which the map view
 * shares. The stream is fetched once, the first time the hook is enabled.
 */
export function useStreamedProjects(t0) {
  const $ = _c(12);
  const {
    companyId,
    projectArchivingState,
    isEnabled
  } = t0;
  const dispatch = useAppDispatch();
  const {
    handleErrorWithToast
  } = useErrorContext();
  const fetchingStatus = useAppSelector(mapProjectsFetchingStatusSelector);
  let t1;
  if ($[0] !== projectArchivingState) {
    t1 = mapProjectsByArchivingStateSelector(projectArchivingState);
    $[0] = projectArchivingState;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const projectsByArchivingStateSelector = t1;
  const projects = useAppSelector(projectsByArchivingStateSelector);
  let t2;
  let t3;
  if ($[2] !== companyId || $[3] !== dispatch || $[4] !== fetchingStatus || $[5] !== handleErrorWithToast || $[6] !== isEnabled) {
    t2 = () => {
      if (!isEnabled || !companyId || fetchingStatus !== "uninitialized") {
        return;
      }
      dispatch(fetchMapProjects({
        companyId
      })).unwrap().catch(error => {
        handleErrorWithToast({
          id: `fetchStreamedProjects-${Date.now().toString()}`,
          title: "Failed to load the projects",
          error
        });
      });
    };
    t3 = [companyId, dispatch, fetchingStatus, handleErrorWithToast, isEnabled];
    $[2] = companyId;
    $[3] = dispatch;
    $[4] = fetchingStatus;
    $[5] = handleErrorWithToast;
    $[6] = isEnabled;
    $[7] = t2;
    $[8] = t3;
  } else {
    t2 = $[7];
    t3 = $[8];
  }
  useEffect(t2, t3);
  let t4;
  if ($[9] !== fetchingStatus || $[10] !== projects) {
    t4 = {
      projects,
      fetchingStatus
    };
    $[9] = fetchingStatus;
    $[10] = projects;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
}